__turbopack_context__.v({
  "button": "Product-module__iCAl3q__button",
  "control": "Product-module__iCAl3q__control",
  "dialogBackdrop": "Product-module__iCAl3q__dialogBackdrop",
  "dialogPanel": "Product-module__iCAl3q__dialogPanel",
  "root": "Product-module__iCAl3q__root",
});
